import { OOCanvas } from "./oo-canvas";
import { OOMenuItem } from "./oo-menu-item";

export class OOMenuItemCanvas {
	venueKey: number;

	canvasKey: number;

	menuItemKey: number;

	online?: boolean;

	min?: number;

	max?: number;

	sortOrder: number;
	includedItemCanvas: boolean;
	source: number;

	ooMenuItem?: OOMenuItem;

	ooCanvas?: OOCanvas;

	unsaved: boolean; //not provided by API; local var only

	public constructor(init?: Partial<OOMenuItemCanvas>) {
		Object.assign(this, init);
	}
}
